var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"promos"},[_c('CreatePromoDialog',{on:{"promo-created":_vm.created}}),_c('PromosTable',{ref:"table"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }